module.exports = "<h3 class=\"mt-0\">{{$ctrl.stepTitle}}</h3>\n<ng-form name=\"$ctrl.$stepsCtrl.forms[$ctrl.uniqueFormId]\">\n  <ng-transclude\n    ng-init=\"$ctrl.stepForm = $ctrl.$stepsCtrl.forms[$ctrl.uniqueFormId]\"\n  ></ng-transclude>\n</ng-form>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/formStep/formStep.html
// module id = 1158
// module chunks = 0